import React from 'react';

import FileUpload from '~components/FileUpload';

interface ComponentProps {
  value: any;
  onChange?: (name: string, value: any) => any;
}

const listItems = [
  'XML format only',
  'Maximum file size: 10 MB',
  'Must contain valid payment summary data',
  'Government and co-contribution details required',
];

const Upload: React.FC<ComponentProps> = ({ value, onChange }) => {
  const existingFile: File | null = value?.file ?? null;

  const handleFileChange = (file: File) => {
    onChange?.('upload.file', file);
  };

  return (
    <div className="d-flex flex-column gap-2 bg-light rounded p-3 mb-3">
      <h6 className="fw-semibold mb-1">Upload XML Payment Summary</h6>
      <FileUpload
        allowedExtensions={['.xml']}
        allowedMimeTypes={['application/xml', 'text/xml']}
        onChange={handleFileChange}
        label="Upload XML File"
        description="Drag and drop your XML payment summary file here, or click to browse"
        className="w-100"
        existingFileName={existingFile?.name ?? null}
      ></FileUpload>
      <div className="criteria-box bg-light p-2 rounded small mt-2">
        <div className="fw-semibold mb-2">File Requirements:</div>
        <ul className="mb-0 ps-3 text-muted">
          {listItems.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Upload;
